import { useEffect, useState } from 'react';
import { Box, FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import usePricingGroupApi, { PricingGroup } from '../../api/PricingGroupApi';

interface Props {
  readonly customerId?: number;
  readonly assignedPricingGroup?: PricingGroup|null;
  readonly selectedPricingGroupId?: number;
  readonly onPricingGroupSelected: (pricingGroup: PricingGroup) => void;
}

const useStyles = makeStyles(theme => ({
  select: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    width: 400,
  }
}));

const PricingGroupSelection = (props: Props) => {
  const classes = useStyles();
  const pricingGroupApi = usePricingGroupApi();
  const assignedPricingGroup = props.assignedPricingGroup;
  const [pricingGroups, setPricingGroups] = useState<PricingGroup[]>([]);
  const [selectedPricingGroup, setSelectedPricingGroup] = useState<PricingGroup|undefined>();

  const fetchPricingGroups = () => {
    pricingGroupApi
      .fetchPricingGroups()
      .then(data => setPricingGroups(data as []))
      .catch(reason => console.error(`Could not fetch pricing groups: ${reason}`));
  };

  const handlePricingGroupSelectionChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const pricingGroupId = event.target.value as number;
    const pricingGroup = findPricingGroupById(pricingGroupId);
    if (pricingGroup !== undefined) {
      setSelectedPricingGroup(pricingGroup);
      props.onPricingGroupSelected(pricingGroup);
    }
  };

  const renderPricingGroupMenuItem = (pricingGroup: PricingGroup) =>
    <MenuItem value={ pricingGroup.id }>{ pricingGroup.name }</MenuItem>;

  const findPricingGroupById = (pricingGroupId: number) =>
    pricingGroups.find(pricingGroup => pricingGroup.id === pricingGroupId);

  useEffect(() => fetchPricingGroups(), []);

  useEffect(() => {
    if (assignedPricingGroup !== undefined) {
      if (assignedPricingGroup === null) {
        setSelectedPricingGroup(undefined);
      } else {
        const pricingGroup = findPricingGroupById(assignedPricingGroup.id);
        setSelectedPricingGroup(pricingGroup);
      }
    }
  }, [assignedPricingGroup, props.customerId]);

  return <Box display="flex" flexDirection="row" justifyContent="flex-start">
      { pricingGroups && <FormControl
        className={ classes.select }
        variant='standard'
      >
        <InputLabel id="pricingGroup-selection-label" shrink={ true }>Grupa cenowa</InputLabel>
        <Select
            labelId='pricingGroup-selection-label'
            value={ selectedPricingGroup?.id || null }
            id='pricingGroup-selection'
            onChange={ handlePricingGroupSelectionChange }
          >
            { pricingGroups.map(renderPricingGroupMenuItem) }
          </Select>
        </FormControl>}
      </Box>;
};

export default PricingGroupSelection;